import Vue from "vue";

Vue.component("hs-products", {
	props: ["placeholder", "language", "hsVersionCode", "productCodes", "notificationId", "filteredHsCodes", "label", "isReadOnly", "list"],
	data() {
		return {
			hsProducts: [],
			selectedHSCodes: [],
			items: []
		};
	},
	computed: {
		hsCodeLabel() {
			return htmlEntity.decode(window.labels.hsCodes);
		},
		hsCodes: {
			get() {
				const text = this.filteredHsCodes;
				if (!text) return [];
				return this.filteredHsCodes;
			}
		}
	},
	methods: {
		onlyUnique: function (value, index, self) {
			return self.indexOf(value) === index;
		},
		getHSProductsForTreeSelect: function (val) {
			this.$services.hsProducts.getForTreeSelect({
				language: this.language,
				hsVersionCode: val
			})
				.then((data) => {
					this.hsProducts = data.items;
					const items = [];
					data.items.forEach(function (t1) {
						items.push({ id: t1.id, code: t1.code, version: t1.version, description: t1.description });
						t1.children.forEach(function (t2) {
							items.push({ id: t2.id, code: t2.code, version: t2.version, description: t2.description });
							t2.children.forEach(function (t3) {
								items.push({ id: t3.id, code: t3.code, version: t3.version, description: t3.description });
								t3.children.forEach(function (t4) {
									items.push({ id: t4.id, code: t4.code, version: t4.version, description: t4.description });
									t4.children.forEach(function (t5) {
										items.push({ id: t5.id, code: t5.code, version: t5.version, description: t5.description });
									});
								});
							});
						});
					});
					
					this.items = items;
					this.$emit("update:list", items);
				});
		},
		updateSelectedHsCodes: function (selectedHsCodes) {
			this.$emit("update:filteredHsCodes", selectedHsCodes);
			this.setProductCodes(selectedHsCodes);			
		},
		setProductCodes: function (selectedHsCodes) {
			if (selectedHsCodes) {
				const returnValue = this.items.filter(i => selectedHsCodes.includes(i.id));	
				this.$emit("update:productCodes", returnValue.map(t => t.code));
			}
		},
		getDataSourceTreeViewText: (dataSource, value) => {
			if (dataSource) {
				const items = dataSource.filter(i => value.includes(i.id));
				var returnValue = "";
				items.forEach(function (item) {
					returnValue += `${item.code} - ${item.description}; `;
				});
				return returnValue;
			}
			return "";
		},
		onDataChange: function(value){
			this.$emit('on-data-change', value)
		}
	},
	mounted() {
		if (this.hsVersionCode) {
			this.getHSProductsForTreeSelect(this.hsVersionCode);
		}
	},
	watch: {
		'hsVersionCode': function (val) {
			if (val) {
				this.getHSProductsForTreeSelect(val);
			}
		}
	},
	template: `
		<section>
			<wto-tree-select @on-data-change="onDataChange" v-if="!isReadOnly" ref="hsProductTreeSelect" @update-selected-options="updateSelectedHsCodes" :filtered-options.sync="hsCodes"  :options="hsProducts" :placeholder="placeholder" tree-id="hs-tree-select-container" />
			<div v-if="isReadOnly" class="textarea wto-textarea-editor-readonly" style="min-height: 60px !important">{{ getDataSourceTreeViewText(items, filteredHsCodes) }}</div>
		</section>
	`
});